import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered notifications"
// error triggered by cmdk/Radix components (Command list + Popover) re-measuring during
// filtering. Deferring the observer callback to the next frame breaks the sync loop.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || entries.length) callback(entries, observer);
        });
      });
    }
  };
  // Extra guard: keep the dev error overlay from surfacing the benign RO message.
  const isRoLoopError = (msg) => typeof msg === "string" && msg.includes("ResizeObserver loop");
  window.addEventListener("error", (e) => {
    if (isRoLoopError(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
